<template>
  <nav>
    <!-- Removed legacy 'exact' prop which is deprecated in Vue 3 Router -->
    <router-link to="/versions">Versions</router-link>
    <router-link to="/customers">Customers</router-link>
    <router-link to="/billing">Billing</router-link>
    <router-link to="/jobs">Jobs</router-link>
    <router-link to="/logs">Logs</router-link>
  </nav>
</template>

<script>
export default {
  name: "AppNavigation" // Explicit naming provides clean component debugging in Vue 3
};
</script>
